import { useBranding } from '../brand/BrandingProvider'
import { runtimeConfig } from '../runtimeConfig'
import { Stack, Standalone } from './layout'

/*
  Brief §2.6, §8.1: in production the app refuses to run on any host other than the canonical
  origin, so a mistyped, copied or retired address cannot pass itself off as the ranch's app.
*/
export function WrongAddress() {
  const branding = useBranding()
  const canonical = runtimeConfig().canonicalOrigin || branding.canonicalOrigin

  return (
    <Standalone testId="wrong-address">
      <Stack>
        <h2>Wrong address</h2>
        <p className="m-0">
          {branding.productName} runs at one address. This page is at{' '}
          <code>{window.location.origin}</code>.
        </p>
        {canonical && (
          <a className="btn btn-primary" href={canonical}>
            Open {canonical.replace(/^https?:\/\//, '')}
          </a>
        )}
        <p className="hint m-0">
          If this address was given to you by your ranch, ask them to confirm it
          {branding.supportEmail ? `; support: ${branding.supportEmail}` : ''}.
        </p>
      </Stack>
    </Standalone>
  )
}
